import { render, staticRenderFns } from "./sopStats.vue?vue&type=template&id=0b07c464&"
import script from "./sopStats.vue?vue&type=script&lang=js&"
export * from "./sopStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports